import LinkHTML from "./LinkHTML";

export default LinkHTML;
